import { Contrast as Diagnostic } from "../diagnostic/contrast.js";
import { Err, Ok } from "@siteimprove/alfa-result";
export var Contrast;
(function (Contrast) {
    Contrast.HasSufficientContrast = (highest, threshold, pairings) => Ok.of(Diagnostic.of(`The highest possible contrast of the text is ${highest}:1 which is
        above the required contrast of ${threshold}:1`, threshold, pairings));
    Contrast.HasInsufficientContrast = (highest, threshold, pairings) => Err.of(Diagnostic.of(`The highest possible contrast of the text is ${highest}:1 which is
        below the required contrast of ${threshold}:1`, threshold, pairings));
})(Contrast || (Contrast = {}));
//# sourceMappingURL=contrast.js.map